import { Pipe, PipeTransform } from "@angular/core";
import { formatMomentWithUserPreference } from "../utils/time-format-preference";

@Pipe({
  name: "userDateTime",
})
export class UserDateTimePipe implements PipeTransform {
  transform(value: any, format24 = "ddd DD, HH:mm", format12 = "ddd DD, hh:mm A"): string {
    if (value == null || value === "") {
      return "";
    }

    return formatMomentWithUserPreference(value, format24, format12);
  }
}
